module.exports = __webpack_public_path__ + "static/media/guide2.b8cd9f82.png";